import updateSetWorkoutExerciseAction from '../update-set'
import { getCurrentSetWorkoutExerciseSelect } from '../../selectors/get-current-set'
import { updateWeightKeySetDataUtil } from '../../../model'

function updateSetWeightKeyWorkoutExerciseAction (value) {
  return (dispatch, getState) => {
    const set = getCurrentSetWorkoutExerciseSelect(getState())
    dispatch(updateSetWorkoutExerciseAction({
      set: updateWeightKeySetDataUtil(set, value),
      key: value,
      shouldNotSave: true
    }))
  }
}

export { updateSetWeightKeyWorkoutExerciseAction }
